'use client'
import { createContext, PropsWithChildren } from 'react'

export type ServerContextType = {
  CMS_BASE_URL: string
}

export const ServerContext = createContext<ServerContextType>({
  CMS_BASE_URL: '',
})

export const ServerContextProvider = ({
  children,
  ...props
}: PropsWithChildren<ServerContextType>) => {
  return <ServerContext.Provider value={props}>{children}</ServerContext.Provider>
}
